import { AutoCompleteOption } from "../components/form/APAutoComplete";
import { ToggleButtonOption } from "../components/form/APFormToggleGroup";

export function buildAutoCompleteOptions(
  items: Record<string, unknown>[],
  labelKey: string,
  idKey: string
): AutoCompleteOption[] {
  const options: AutoCompleteOption[] = [];
  const optionIds: string[] = [];
  items.forEach((item) => {
    const id = `${item[idKey]}`;

    if (!optionIds.includes(id)) {
      options.push({ label: `${item[labelKey]}`, id });
      optionIds.push(id);
    }
  });

  return options;
}

export function buildAutoCompleteOptionsFromArray(
  items: (string | number)[],
  labelMap?: Record<string | number, string>
): AutoCompleteOption[] {
  return items.map((item) => ({
    label: `${labelMap ? labelMap[item] : `${item}`}`,
    id: `${item}`,
  }));
}

export function getAutoCompleteLabel(
  options: AutoCompleteOption[] | ToggleButtonOption[],
  optionId: string
) {
  const option = options.find((option) => option.id === optionId);

  return option ? option.label : "";
}

export function findAutoCompleteOptionById(
  items: Record<string, unknown>[],
  idKey: string,
  labelKey: string,
  targetId: string
): AutoCompleteOption | null {
  const item = items.find((item) => `${item[idKey]}` === targetId);

  if (item) {
    return {
      id: `${item[idKey]}`,
      label: `${item[labelKey]}`,
    };
  }

  return null;
}
